import React from "react";
import { PopupSection } from "src/app/components/PopUp/components/PopupSection";
import { AccessFields } from "../components/AccessFields/AccessFields";
import { ISelectOption } from "src/app/project/ProjectTypes";

interface Props {
  type: ISelectOption;
}

export const CreateFormFields = ({ type }: Props) => {
  return (
    <PopupSection className="details-popup__access-fields">
      <AccessFields type={type} />
    </PopupSection>
  );
};
